import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { nameof } from '@symphony-solo/shared/utils/src';
import { ISelectProductFeature } from './select-product.feature.state';
import { SelectProductState } from './select-product.state';

export const getSelectProductState: MemoizedSelector<ISelectProductFeature, SelectProductState> = createFeatureSelector<SelectProductState>(
  nameof<ISelectProductFeature>('selectProduct')
);

export const getIsLoading = createSelector(getSelectProductState, (state: SelectProductState) => state.isLoading);

export const getFailures = createSelector(getSelectProductState, (state: SelectProductState) => state.failures);
